// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edume-more{display:flex;padding:12px;align-items:center;justify-content:space-between;gap:8px;align-self:stretch;box-shadow:0 1px 2px rgba(32,32,33,.06),0 2px 8px rgba(32,32,33,.1);margin-top:12px;border-radius:4px}.edume-see-all-link{font-size:16px;font-weight:700;line-height:20px;text-decoration:none}.edume-is-full-width{width:100%}.edume-more-content-message{color:#000;size:16px;font-weight:400;line-height:20px}", ""]);
// Exports
module.exports = exports;
